export const CLIENT_ID = 'icLhM0lJi6AIhimXSw5AJeRrFDtWQqHo';
export const CLIENT_SECRET = '8cRTl93DdKzigeDfovuKyoQU6VyFb8riUlOzErplZDXe2dKULqfW3hM6zChSYfk2Dvs2zijMbL42WK5pmaG79EmbhsFAZZ1Z5vN89iJqAlxl9QlB4H6Nh4jLKY6QM8IO';
export const DEFAULT_SCOPES = [
  'read write users:read users:write links:read links:write themes:read themes:write',
  'analytics:read analytics:write billing:read billing:write',
  'user_messages:read user_messages:write',
].join(' ');

export const REGISTRATE_USER_SUCCESS = 'USERS/REGISTRATE_USER_SUCCESS';
export const REGISTRATE_USER_ERROR = 'USERS/REGISTRATE_USER_ERROR';
export const CLEAR_REGISTRATE_USER = 'USERS/CLEAR_REGISTRATE_USER';

export const VERIFY_REGISTRATION_EMAIL_SUCCESS = 'USERS/VERIFY_REGISTRATION_EMAIL_SUCCESS';
export const VERIFY_REGISTRATION_EMAIL_ERROR = 'USERS/VERIFY_REGISTRATION_EMAIL_ERROR';

export const LOGGED_IN = 'USERS/LOGGED_IN';
export const LOGIN_ERROR = 'USERS/LOGIN_ERROR';
export const CLEAR_LOGIN_ERROR = 'USERS/CLEAR_LOGIN_ERROR';

export const UNAUTHORIZED = 'USERS/UNAUTHORIZED';
export const RESET_UNAUTHORIZED = 'USERS/RESET_UNAUTHORIZED';

export const FETCH_ME = 'USERS/FETCH_ME';
export const FETCH_ME_ERROR = 'USERS/FETCH_ME_ERROR';

export const LOGGING_OUT = 'USERS/LOGGING_OUT';
export const LOGGED_OUT = 'USERS/LOGGED_OUT';

export const REFRESH_TOKEN = 'USERS/REFRESH_TOKEN';
export const REFRESH_TOKEN_ERROR = 'USERS/REFRESH_TOKEN_ERROR';

export const SEND_PASSWORD_RESET_LINK_SUCCESS = 'USERS/SEND_PASSWORD_RESET_LINK_SUCCESS';
export const SEND_PASSWORD_RESET_LINK_ERROR = 'USERS/SEND_PASSWORD_RESET_LINK_ERROR';
export const CLEAR_SEND_PASSWORD_RESET_LINK = 'USERS/ClEAR_SEND_PASSWORD_RESET_LINK';

export const RESET_PASSWORD_SUCCESS = 'USERS/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'USERS/RESET_PASSWORD_ERROR';
export const CLEAR_RESET_PASSWORD = 'USERS/CLEAR_RESET_PASSWORD';

export const CONFIRMATION_RESENT_SUCCESS = 'USERS/CONFIRMATION_RESENT_SUCCESS';
export const CONFIRMATION_RESENT_ERROR = 'USERS/CONFIRMATION_RESENT_ERROR';
export const CLEAR_CONFIRMATION_RESENT = 'USERS/CLEAR_CONFIRMATION_RESENT';

export const FETCH_COUNTRIES_SUCCESS = 'USERS/FETCH_COUNTRIES_SUCCESS';
export const FETCH_COUNTRIES_ERROR = 'USERS/FETCH_COUNTRIES_ERROR';

export const SOCIAL_LOGIN = 'USERS/SOCIAL_LOGIN';
export const SOCIAL_LOGIN_ERROR = 'USERS/SOCIAL_LOGIN_ERROR';

export const ADMIN_SET_TOKENS = 'USERS/ADMIN_SET_TOKENS';

export const TOGGLE_LIVECHAT = 'USERS/TOGGLE_LIVECHAT';
export const SET_ME = 'USERS/SET_ME';

export const CHANGE_SHORT_USERNAME_SUCCESS = 'USERS/CHANGE_SHORT_USERNAME_SUCCESS';
export const CHANGE_SHORT_USERNAME_ERROR = 'USERS/CHANGE_SHORT_USERNAME_ERROR';
export const CLEAR_CHANGE_SHORT_USERNAME = 'USERS/CLEAR_CHANGE_SHORT_USERNAME';

export const GENERATE_QRCODE_USER_SUCCESS = 'USERS/GENERATE_QRCODE_USER_SUCCESS';
export const GENERATE_QRCODE_USER_ERROR = 'USERS/GENERATE_QRCODE_USER_ERROR';
export const CLEAR_GENERATE_QRCODE_USER = 'USERS/CLEAR_GENERATE_QRCODE_USER';

export const FETCH_PAGE_BLOCK_ITEMS_LIST = 'USERS/FETCH_PAGE_BLOCK_ITEMS_LIST';
export const FETCH_PAGE_BLOCK_ITEMS_LIST_ERROR = 'USERS/FETCH_PAGE_BLOCK_ITEMS_LIST_ERROR';
export const CLEAR_FETCH_PAGE_BLOCK_ITEMS_LIST = 'USERS/CLEAR_FETCH_PAGE_BLOCK_ITEMS_LIST';

export const APPLY_PAGE_BLOCK_ITEM_DRAG = 'USERS/APPLY_PAGE_BLOCK_ITEM_DRAG';
export const APPLY_PAGE_BLOCK_ITEM_DRAG_ERROR = 'USERS/APPLY_PAGE_BLOCK_ITEM_DRAG_ERROR';
export const CLEAR_APPLY_PAGE_BLOCK_ITEM_DRAG = 'USERS/CLEAR_APPLY_PAGE_BLOCK_ITEM_DRAG';

export const CHANGE_EMAIL_SUCCESS = 'USERS/CHANGE_EMAIL_SUCCESS';
export const CHANGE_EMAIL_ERROR = 'USERS/CHANGE_EMAIL_ERROR';
export const CLEAR_CHANGE_EMAIL = 'USERS/CLEAR_CHANGE_EMAIL';

export const CHANGE_PASSWORD_SUCCESS = 'USERS/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'USERS/CHANGE_PASSWORD_ERROR';
export const CLEAR_CHANGE_PASSWORD = 'USERS/CLEAR_CHANGE_PASSWORD';

export const CREATE_TOTP_SUCCESS = 'USERS/CREATE_TOTP_SUCCESS';
export const CREATE_TOTP_ERROR = 'USERS/CREATE_TOTP_ERROR';
export const CLEAR_CREATE_TOTP = 'USERS/CLEAR_CREATE_TOTP';

export const DELETE_TOTP_SUCCESS = 'USERS/DELETE_TOTP_SUCCESS';
export const DELETE_TOTP_ERROR = 'USERS/DELETE_TOTP_ERROR';
export const CLEAR_DELETE_TOTP = 'USERS/CLEAR_DELETE_TOTP';

export const FETCH_TWFA_QRCODE_SUCCESS = 'USERS/FETCH_TWFA_QRCODE_SUCCESS';
export const FETCH_TWFA_QRCODE_ERROR = 'USERS/FETCH_TWFA_QRCODE_ERROR';
export const CLEAR_FETCH_TWFA_QRCODE = 'USERS/CLEAR_FETCH_TWFA_QRCODE';

export const ENABLE_TOTP_SUCCESS = 'USERS/ENABLE_TOTP_SUCCESS';
export const ENABLE_TOTP_ERROR = 'USERS/ENABLE_TOTP_ERROR';
export const CLEAR_ENABLE_TOTP = 'USERS/CLEAR_ENABLE_TOTP';

export const FETCH_TWFA_ENABLED_SUCCESS = 'USERS/FETCH_TWFA_ENABLED_SUCCESS';
export const FETCH_TWFA_ENABLED_ERROR = 'USERS/FETCH_TWFA_ENABLED_ERROR';
export const CLEAR_FETCH_TWFA_ENABLED = 'USERS/CLEAR_FETCH_TWFA_ENABLED';

export const VALIDATE_USERNAME_SUCCESS = 'USERS/VALIDATE_USERNAME_SUCCESS';
export const VALIDATE_USERNAME_ERROR = 'USERS/VALIDATE_USERNAME_ERROR';
export const CLEAR_VALIDATE_USERNAME = 'USERS/CLEAR_VALIDATE_USERNAME';

export const SET_LANG_SUCCESS = 'USERS/SET_LANG_SUCCESS';
export const SET_LANG_ERROR = 'USERS/SET_LANG_ERROR';
